var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { getPopupPosition } from "../../../../lib/utils/styling";
import UcWindow from "../../../../lib/UcWindow";
import GlobalPluginsArgsSettingPanel from './globalPluginsArgsSettingPanel';
const width = '470';
let GlobalComponentPluginArgsDialog = class GlobalComponentPluginArgsDialog extends Vue {
  constructor() {
    super(...arguments);
    this.left = '50%';
    this.top = '25px';
    this.shown = false;
    this.args = '';
    this.globalPlugins = [];
    this.selectedPlugins = [];
  }
  get unSelectedPlugins() {
    return this.globalPlugins.filter(p => !this.selectedPlugins.find(plugin => plugin.id === p.id));
  }
  created() {
    const {
      componentPlugins
    } = this.uc;
    this.globalPlugins = Object.values(componentPlugins).filter(p => p.global);
    this.selectedPlugins = this.getSelectedPlugins();
  }
  getSelectedPlugins() {
    var _this$designer$rootPa;
    const selectedPluginKeys = Object.keys(((_this$designer$rootPa = this.designer.rootPagelet) === null || _this$designer$rootPa === void 0 ? void 0 : _this$designer$rootPa.globalPluginArgs) || {});
    return selectedPluginKeys.map(k => ({
      args: this.getGlobalPluginArgs(k),
      ...this.getSelectedPluginConfigByKey(k)
    }));
  }
  getSelectedPluginConfigByKey(key) {
    const config = this.globalPlugins.find(p => p.id === key);
    if (!config) {
      throw new Error(`没有找到id为${key}的插件`);
    }
    return {
      id: config.id,
      name: config.name
    };
  }
  // 获取某一个插件的公共参数
  getGlobalPluginArgs(pluginId) {
    if (!this.designer.rootPagelet) return;
    if (!this.designer.rootPagelet.globalPluginArgs) {
      return;
    }
    return this.designer.rootPagelet.globalPluginArgs[pluginId];
  }
  // 设置某一个插件的公共参数
  setGlobalPluginArgs(pluginArgs) {
    if (!this.designer.rootPagelet) return;
    if (!this.designer.rootPagelet.globalPluginArgs) {
      this.$set(this.designer.rootPagelet, 'globalPluginArgs', {});
    }
    this.$set(this.designer.rootPagelet.globalPluginArgs, pluginArgs.id, pluginArgs.args);
    this.designer.uc.notifyPageletsChange();
    const pluginToBeChanged = this.selectedPlugins.find(p => p.id === pluginArgs.id);
    if (pluginToBeChanged) {
      pluginToBeChanged.args = pluginArgs.args;
    }
  }
  handlePluginSelected(plugin) {
    if (!plugin) return;
    if (!this.designer.rootPagelet.globalPluginArgs) this.$set(this.designer.rootPagelet, 'globalPluginArgs', {});
    this.$set(this.designer.rootPagelet.globalPluginArgs, plugin, '');
    this.designer.uc.notifyPageletsChange();
    this.selectedPlugins.push({
      args: '',
      ...this.getSelectedPluginConfigByKey(plugin)
    });
  }
  handlePluginArgsDelete(id) {
    delete this.designer.rootPagelet.globalPluginArgs[id];
    this.designer.uc.notifyPageletsChange();
    this.selectedPlugins.splice(this.selectedPlugins.findIndex(p => p.id === id), 1);
  }
  handlePluginArgsChange(e) {
    this.setGlobalPluginArgs({
      id: e.id,
      args: e.args
    });
  }
  render() {
    const h = arguments[0];
    if (!this.shown) return null;
    return h("uc-window", {
      "attrs": {
        "left": this.left,
        "top": this.top,
        "width": `${width}px`,
        "title": '编辑全局插件的公共参数',
        "visible": true
      },
      "on": {
        "close": this.cancel
      }
    }, [h("div", {
      "class": "uc-reportDimsToolbar"
    }, [h("div", {
      "class": "uc-reportDims-list"
    }, [h("p", ["\u7F16\u8F91\u516C\u5171\u53C2\u6570"]), this.selectedPlugins.map(p => h(GlobalPluginsArgsSettingPanel, {
      "attrs": {
        "plugin": p
      },
      "on": {
        "change": this.handlePluginArgsChange,
        "delete": this.handlePluginArgsDelete
      }
    })), this.unSelectedPlugins.length > 0 && h("select", {
      "class": "uc-inputbox",
      "style": 'width:100%;margin-top:16px',
      "on": {
        "change": e => {
          this.handlePluginSelected(e.target.value);
          e.target.selectedIndex = 0;
        }
      }
    }, [h("option", {
      "attrs": {
        "value": "",
        "selected": true,
        "hidden": true
      }
    }, ["\u9009\u62E9\u63D2\u4EF6"]), this.unSelectedPlugins.map(plugin => h("option", {
      "domProps": {
        "value": plugin.id
      }
    }, [plugin.name]))])])])]);
  }
  cancel() {
    var _this$respondAndClose;
    (_this$respondAndClose = this.respondAndClose) === null || _this$respondAndClose === void 0 || _this$respondAndClose.call(this, null);
  }
  show(opt) {
    return new Promise(resolve => {
      const position = getPopupPosition({
        anchor: opt.place || document.activeElement,
        container: this.designer.$el,
        width: parseInt(width, 10),
        height: 400
      });
      this.left = `${position.x}px`;
      this.top = `${position.y}px`;
      this.shown = true;
      this.respondAndClose = globalPluginArgs => {
        resolve(globalPluginArgs);
        this.shown = false;
        this.respondAndClose = undefined;
      };
    });
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], GlobalComponentPluginArgsDialog.prototype, "designer", void 0);
__decorate([Inject(INJECT_UICORE_BUS)], GlobalComponentPluginArgsDialog.prototype, "uc", void 0);
GlobalComponentPluginArgsDialog = __decorate([Component({
  name: 'GlobalComponentPluginArgsDialog',
  components: {
    UcWindow,
    GlobalPluginsArgsSettingPanel
  }
})], GlobalComponentPluginArgsDialog);
export default GlobalComponentPluginArgsDialog;
//# sourceMappingURL=GlobalPluginArgsDialog.js.map
